<template>
  <div class="colu colu-12">
    <label class="colu-12 for-label colu-mr-t" for="destination-tag-input">
      {{ $t('Bao.destination_tag') }}
    </label>
    <div class="inp-relative">
      <input
        id="destination-tag-input"
        :value="memo"
        autocomplete="off"
        class="for-input inpType fs-14-w-700"
        :placeholder="$t('Bao.destination_tag')"
        type="text"
        @input="$emit('update:memo', $event.target.value)"
      >
      <button
        class="btn btn-keyChainCopy"
        @click.prevent="$emit('copy', memo)"
      />
    </div>
    <div class="input-feedback remarks">
      <div class="row-frame">
        <div class="colu-auto icon-pr-1">
          <i class="icon-alert">
            <img :src="$getThemeImagePath('icon_alert.png')" alt="">
          </i>
        </div>
        <div class="colu-11 fs-14px pl-0 fs-remarks-box">
          {{ $t('Bao.destination_tag_describe') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DestinationTagInput',
  props: {
    memo: {
      type: String,
      default: ''
    }
  }
}
</script>
